var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDarkShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "scsxcgnnxa",
    d: "M0 0.029L27.152 0.029 27.152 27.182 0 27.182z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1.395 1.395)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "8vjl15eg3b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#scsxcgnnxa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C1E266",
    d: "M13.576 1.52c-6.664 0-12.085 5.422-12.085 12.086 0 6.663 5.421 12.085 12.085 12.085 6.664 0 12.085-5.422 12.085-12.085 0-6.664-5.421-12.086-12.085-12.086m0 25.662C6.09 27.182 0 21.092 0 13.606 0 6.12 6.09.029 13.576.029c7.486 0 13.576 6.09 13.576 13.577 0 7.486-6.09 13.576-13.576 13.576",
    mask: "url(#8vjl15eg3b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#283049",
    d: "M21.172 6.263c-1.763.766-3.748 3.443-4.024 5.638l1.27-1.17c-.472 1.591-.758 3.172-.976 4.517l-.005.038c0 .01-.002.019-.004.028-.122.697-.321.868-1.007.86-.47-.004-.987-.038-1.625-.107-.39-.042-.557-.22-.574-.615-.02-.486-.02-.982-.02-1.462v-.361-4.346l1.098 1.47c-.087-2.455-.542-4.815-1.755-7.062h-.007c-1.213 2.247-1.668 4.607-1.755 7.063l1.152-1.542v1.409c0 1.002 0 2.005-.002 3.008v.36c0 .48.001.977-.02 1.463-.016.395-.182.573-.572.615-.639.07-1.155.103-1.626.107-.691.006-.885-.163-1.007-.86l-.004-.028-.005-.038c-.217-1.34-.501-2.912-.97-4.495l1.27 1.169C9.728 9.727 7.744 7.05 5.98 6.283l.065.18c.481 1.344.95 2.69 1.35 4.054l.05.166c.682 2.324 1.04 4.293 1.129 6.196.03.654.384.981 1.08 1l.135.004c.395.01.804.02 1.2.06.965.096 1.502.548 1.741 1.467.104.398.16.838.165 1.27.014 1.267.012.407.01 1.653l-.001.902c0 .18.069.347.196.474.126.127.294.196.473.196.18 0 .347-.07.474-.196.126-.127.196-.295.196-.474l-.002-.902c-.002-1.246-.004-.386.01-1.653.005-.432.062-.872.165-1.27.239-.919.776-1.37 1.741-1.467.396-.04.805-.05 1.2-.06l.135-.004c.697-.019 1.05-.346 1.08-1 .09-1.92.455-3.91 1.15-6.262l.055-.188c.395-1.34.857-2.665 1.33-3.986l.065-.18"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDarkShort);
export default __webpack_public_path__ + "static/media/logo-dark-short.6e6ddd7d6073a9f055ba6d948831bfa3.svg";
export { ForwardRef as ReactComponent };